import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "./contexts/LangContext";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Pools from "./pages/Pools";
import CreatePool from "./pages/CreatePool";
import PoolDetail from "./pages/PoolDetail";
import KYC from "./pages/KYC";
import Wallet from "./pages/Wallet";
import Earn from "./pages/Earn";
import Admin from "./pages/Admin";
import Notifications from "./pages/Notifications";
import FreeRoulette from "./pages/FreeRoulette";
import Games from "./pages/Games";
import Profile from "./pages/Profile";
import PromoAds from "./pages/PromoAds";
import NativeBanner from "./components/NativeBanner";
import RefLanding from "./pages/RefLanding";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/pools" element={<ProtectedRoute><Pools /></ProtectedRoute>} />
        <Route path="/pools/new" element={<ProtectedRoute><CreatePool /></ProtectedRoute>} />
        <Route path="/pools/:id" element={<ProtectedRoute><PoolDetail /></ProtectedRoute>} />
        <Route path="/kyc" element={<ProtectedRoute><KYC /></ProtectedRoute>} />
        <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
        <Route path="/earn" element={<ProtectedRoute><Earn /></ProtectedRoute>} />
        <Route path="/roulette" element={<ProtectedRoute><FreeRoulette /></ProtectedRoute>} />
        <Route path="/games" element={<ProtectedRoute><Games /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/promo" element={<ProtectedRoute><PromoAds /></ProtectedRoute>} />
        <Route path="/dashboard/ref/:code" element={<RefLanding />} />
        <Route path="/ref/:code" element={<RefLanding />} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      </Routes>
      {/* AdsTerra Native Banner — appears at the bottom of every page */}
      {!["/login", "/register", "/"].includes(location.pathname) && <NativeBanner />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
          <CurrencyProvider>
            <AuthProvider>
              <AppRouter />
              <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0F1F35", border: "1px solid #1A2D4D", color: "#F0F6FF" } }} />
            </AuthProvider>
          </CurrencyProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
